import { nationalTermDescriptor, } from 'models';
import { useFormFullSelector, useFormSelector } from 'mrf/redux/ReduxHelper';
import FormCRUD from 'mrf/view/FormCRUD';
import { Col, Grid } from 'mrf/view/Grid';
import TextField from 'mrf/view/TextField';
import React from 'react';
import { useEffect } from 'react';

export default function NationalTermForm({ history, match, t, rootTermId }) {
    const { id } = match.params

    const context = useFormSelector({
        id: id,
        resource: 'nationalTerms',
        descriptor: nationalTermDescriptor
    });

    const { data, set } = useFormFullSelector(context);

    useEffect(() => {
        set({ rootTermId: rootTermId });
    }, [set, data?.rootTermId, rootTermId]); // eslint-disable-next-line

    return <FormCRUD
        title={t('Root Term')}
        match={match}
        history={history}
        context={context}
    >
        <Grid>
            <Col>
                <TextField
                    label={t('National Term')}
                    field='term'
                    required
                />
            </Col>
        </Grid>
    </FormCRUD>
}